import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
Box, 
Typography, 
Button, 
Container 
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFoundPage = () => {
return (
    <Container>
    <Box
        sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        gap: 2
        }}
    >
        <ErrorOutlineIcon sx={{ fontSize: 100, color: 'error.main' }} />
        <Typography variant="h1" sx={{ fontSize: '4rem', fontWeight: 'bold' }}>
        404
        </Typography>
        <Typography variant="h5">
        Oops! Page not found
        </Typography>
        <Typography variant="body1" color="text.secondary">
        The page you requested could not be found.
        </Typography>
        <Button
        component={RouterLink}
        to="/dashboard"
        variant="contained"
        sx={{ mt: 2 }}
        >
        Return to Dashboard
        </Button>
    </Box>
    </Container>
);
};

export default NotFoundPage;